<div class="flex flex-col gap-1 relative">
  <label [for]="placeholder"  class=" text-xs font-medium" *ngIf="label">{{label}}</label>
  <mat-form-field appearance="outline" [ngClass]="['form-field-wrapper', bgClass, hasError ? 'error-outline':'']">
    <input matInput  [placeholder]="placeholder" readonly [max]="todayDate" [formControl]="dateFormControl"
    [placeholder]="placeholder" [matDatepicker]="picker" (focus)="picker.open()" (click)="picker.open()"
    (ngModelChange)="getValue()">
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>
